import { defineStore } from "pinia";
import loadConfig, { IConfig } from "@/common/config";
import { ref } from "vue";

export const useConfigStore = defineStore("config", () => {
  const config = ref<IConfig>();

  async function getConfig() {
    if (!config.value) config.value = await loadConfig();
  }

  return {
    config,
    getConfig,
  };
});
